import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({data, tableColumns}) => {
    const rows = data ?? [];
    const columns = [
        {id: "capture_time", className: "w-[13%]", renderCell: element => element.capture_time ?? ""},
        {id: "plate", className: "w-[8%]", renderCell: element => element.plate ?? ""},
        {id: "description", className: "w-[54%]", renderCell: element => element.description ?? ""},
        {id: "source", className: "w-[10%]", renderCell: element => element.source ?? ""},
        {id: "reasons", className: "w-[15%]", renderCell: element => element.reasons ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        if (!data) return;
        ReportUtils.createExportableTable(null, null, "Lista de alarmes", "alarm-list-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="alarm-list-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`}>
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.id}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {rows.map((element, index) => (
                        <tr key={index} className="table-break-word">
                            {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;